import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { formatDollars, TWO_DECIMAL_DIGITS } from '../utils/formatting';
import { DOLLAR_PRICE_MIN_VALUE } from '../utils/profits';
import s from './EarningsDisplay.scss';
const EarningsDisplay = ({ dollarPrice , productType , requestEarningsCalculation , estimatedEarningsResponse ={} , className  })=>{
    const { t  } = useTranslation();
    const { dollarEarnings , serviceFeePercentage: feePercentage  } = estimatedEarningsResponse;
    useEffect(()=>{
        if (dollarPrice && productType) {
            requestEarningsCalculation(dollarPrice, productType);
        }
    }, [
        dollarPrice,
        productType,
        requestEarningsCalculation
    ]);
    if (!dollarPrice || +dollarPrice <= DOLLAR_PRICE_MIN_VALUE) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, t('earningsDisplay.label'), ' ', dollarEarnings && /*#__PURE__*/ React.createElement("span", {
        className: s['earnings']
    }, formatDollars(+dollarEarnings, TWO_DECIMAL_DIGITS)), feePercentage && /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        size: "medium",
        placement: "top",
        "aria-label": t('earningsDisplay.tooltip', {
            feePercentage
        }),
        description: t('earningsDisplay.tooltip', {
            feePercentage
        }),
        width: 218
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        className: s['info-icon'],
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })));
};
EarningsDisplay.displayName = 'EarningsDisplay';
export default EarningsDisplay;
